import * as types from './actionTypes';
import {ajaxCallError} from './ajaxStatusActions';
import {Api} from '../api/Api';
import {beginAjaxCall, sinReducerSuccess} from './ajaxStatusActions';


export function getPagosListSuccess(pagos) {
  return {type: types.LOAD_PAGOS_LIST_SUCCESS, pagos};
}



export function getPagosList(pagina, regitrosPorPagina, filtro, showActivos, filtrosCombo, token) {
    
	return dispatch => {
		      dispatch(beginAjaxCall());
		      return Api().PagosApi.getPagosList(pagina, regitrosPorPagina, filtro, showActivos, filtrosCombo, token).then(pagos => {                  
                  dispatch(getPagosListSuccess(pagos));
		      }).catch(error => {
		          dispatch(ajaxCallError());
		  throw(error);
		});
  	};
}


export function getPagosPendientesListSuccess(pagos) {
  return {type: types.LOAD_PAGOS_PENDIENTES_LIST_SUCCESS, pagos};
}

export function getReportePagos(id, token) {
    
	return dispatch => {
		      dispatch(beginAjaxCall());
		      return Api().PagosApi.getReportePagos(id, token).then(pagos => { 
                  dispatch(getPagosPendientesListSuccess(pagos));
                  return(pagos)
		      }).catch(error => {
		          dispatch(ajaxCallError());
		  throw(error);
		});
  	};
}


export function getPagosSuccess(catalogo) {
  return {type: types.LOAD_PAGOS_SUCCESS, catalogo};
}

export function getPagos(id, token) {
    return dispatch => {
        dispatch(beginAjaxCall());  
        return Api().PagosApi.getPagos(id, token).then(pagos => {   
        dispatch(getPagosSuccess(pagos));
        return pagos;
    }).catch(error => {
		dispatch(ajaxCallError()); 
      throw(error);
    });
  };
}




export function getPagosUsuario(token) {
    return dispatch => {
        dispatch(beginAjaxCall());  
        return Api().PagosApi.getPagosUsuario(token).then(pagos => {   
        dispatch(getPagosSuccess(pagos));
        return pagos;
    }).catch(error => {
		dispatch(ajaxCallError()); 
      throw(error);
    });
  };
}




export function saveSuccess(pagos) {
  return {type: types.SAVE_PAGOS_SUCCESS, pagos};
}


export function save(pagos, token) {
    
  return dispatch => {
	dispatch(beginAjaxCall());  
    return Api().PagosApi.save(pagos, token).then(pagosGuardado => {   
    dispatch(saveSuccess(pagosGuardado));
    }).catch(error => {
		dispatch(ajaxCallError()); 
      throw(error);
    });
  };
}


export function saveFecha(pagos, token) {
    
  return dispatch => {
	dispatch(beginAjaxCall());  
    return Api().PagosApi.saveFecha(pagos, token).then(pagoGuardado => {   
    dispatch(saveSuccess(pagoGuardado));
    }).catch(error => {
		dispatch(ajaxCallError()); 
      throw(error);
    });
  };
}




export function getPagosComboSuccess(datos) {
  return {type: types.GET_PAGOSS_COMBO_SUCCESS, datos};
}

export function getPagosCombo(token) {
    
  return dispatch => {
     
	dispatch(beginAjaxCall());  
      
    return Api().PagosApi.getPagosCombo(token).then(datos => {   
        
      dispatch(getPagosComboSuccess(datos));
    }).catch(error => {
		dispatch(ajaxCallError()); 
      throw(error);
    });
  };
}

export function borrarSuccess(pagos) {
  return {type: types.BORRAR_PAGOS_SUCCESS, pagos};
}


export function borrar(id, token ) {    
	return dispatch => {
		      dispatch(beginAjaxCall());
		      return Api().PagosApi.borrar(id, token ).then(pagos => {
               
                  dispatch(borrarSuccess(pagos));
		      }).catch(error => {
		          dispatch(ajaxCallError());
		  throw(error);
		});
  	};
}




export function activarSuccess(pagos) {
  return {type: types.ACTIVAR_PAGOS_SUCCESS, pagos};
}


export function activar(id, token) {    
	return dispatch => {
		      dispatch(beginAjaxCall());
		      return Api().PagosApi.activar(id, token).then(pagos => {
               
                  dispatch(activarSuccess(pagos));
		      }).catch(error => {
		          dispatch(ajaxCallError());
		  throw(error);
		});
  	};
}


export function setFiltro(filtroActivo, filtroActual, showActivos) {
	let filtro={
		filtroActivo,
		filtroActual,
        showActivos
	}
  return {type: types.SET_FILTRO_PAGOS, filtro};
}

export function getPagosPendientes(token) {
    
  return dispatch => {
     
	dispatch(beginAjaxCall());  
      
    return Api().PagosApi.getPagosPendientes(token).then(datos => {   
       
      dispatch(sinReducerSuccess());
         return datos;
    }).catch(error => {
		dispatch(ajaxCallError()); 
      throw(error);
    });
  };
}

